<template>
  <div class="modal">
    <v-snackbar v-model="snackbar" timeout="3000"
      >Aktion erfolgreich ausgeführt.
    </v-snackbar>

    <v-row justify="center">
      <v-dialog
        v-model="dialog"
        persistent
        max-width="600px"
        scrollable
        :fullscreen="$vuetify.breakpoint.xs ? true : false"
        :transition="
          $vuetify.breakpoint.xs
            ? 'dialog-bottom-transition'
            : 'dialog-transition'
        "
      >
        <v-card :disabled="loading">
          <v-card-title>
            <span class="headline">Verlängerung planen</span>
          </v-card-title>
          <v-card-text v-if="!showSuccess">
            <!-- <div class="body-2">
              Die Aktualisierungsrichtlinie für diese Frist erlaubt es,
              Aktualisierungen am eigenen Fristenstatus vorzuschlagen
              (Genehmigungsprozess erforderlich).
            </div> -->
            <v-spacer style="height: 20px"></v-spacer>
            <v-form v-model="formIsValid" @submit.prevent>
              <v-row dense>
                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model="scheduledRenewalUpdate.timestamp"
                    type="date"
                    outlined
                    hide-details="auto"
                    label="Datum"
                    :rules="[rules.required]"
                    class="mb-2"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model="scheduledRenewalUpdate.timestamp"
                    type="time"
                    outlined
                    hide-details="auto"
                    label="Uhrzeit"
                    :rules="[rules.required]"
                    class="mb-2"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model.trim="scheduledRenewalUpdate.location"
                    outlined
                    hide-details="auto"
                    clearable
                    label="Ort"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model.trim="scheduledRenewalUpdate.note"
                    outlined
                    hide-details="auto"
                    clearable
                    label="Bemerkungen"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-text v-if="errorMessage !== ''">
            <v-alert dense text type="error"> {{ errorMessage }} </v-alert>
          </v-card-text>
          <v-card-actions>
            <v-btn text @click="$emit('close')">Abbrechen</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              :disabled="!formIsValid"
              :loading="loading"
              depressed
              color="primary"
              @click="scheduleRenewal()"
            >
              Bestätigen
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import { functions, Timestamp } from "@/firebase";
export default {
  name: "deadline-entry-renewal-dialog",
  props: {
    deadlineEntry: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      rules: {
        required: (value) => !!value || "Ist erforderlich.",
      },
      licenseKey: "",
      formIsValid: false,
      loading: false,
      showSuccess: false,
      errorMessage: "",
      dialog: true,
      snackbar: false,
      scheduledRenewalUpdate: {
        date: "",
        time: "",
        location: "",
        note: "",
      },
    };
  },
  methods: {
    convertToTimestamp(date, time) {
      const input = date + " " + time;
      return Timestamp.fromDate(new Date(input.replace(/-/g, "/")));
    },
    scheduleRenewal() {
      const renewalTimestamp = this.convertToTimestamp(
        this.scheduledRenewalUpdate.date,
        this.scheduledRenewalUpdate.time
      );
      const scheduledRenewalObject = {
        timestamp: renewalTimestamp,
        labels: this.scheduledRenewalUpdate.labels,
        note: this.scheduledRenewalUpdate.note,
      };

      const callFunction = functions.httpsCallable(
        "memberManagement-addscheduledRenewalUpdateRequests"
      );
      callFunction({
        organizationId: this.$route.params.organizationId,
        deadlineId: this.deadlineEntry.deadline.id,
        deadlineEntries: [{ ...scheduledRenewalObject }],
      })
        .then((result) => {
          console.log(result.data);
          if (result.data.success) {
            this.showSuccess = true;
            this.snackbar = true;
            this.loading = false;
            this.$emit("close");
          } else {
            this.errorMessage = "Unbekannter Fehler aufgetreten.";
            this.loading = false;
          }
        })
        .catch((error) => {
          // handle error
          console.error(error);
          this.errorMessage = error.message;
          this.loading = false;
        });
    },
  },
};
</script>
